import * as Yup from "yup"

export const schema=Yup.object().shape({
    username:Yup.string().min(3).max(20).required("please enter a username"),
    email:Yup.string().email().required("enter your mail id"),
    password:Yup.string().min(6).required("enter password").matches(/^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$/, 'Password must be alphanumeric'),
    confirmPassword:Yup.string().required().oneOf([Yup.ref("password"),null],"password must match")

})